export const SERVER_CONFIG = {
  LOCAL_SERVER_IP: 'http://localhost:5003',
  SERVER_IP: 'https://backend.graduatesguildvnb.com',
  SERVER_Dev: 'https://backend.dev.graduatesguildvnb.com',
};
